import React from 'react';
import './DesktopRight.css';
import pcCharacter from '../assets/网站设计/PC端切图/pc_character2.webp';
import icon_discord from '../assets/icons/icon-11.webp' // Discord
import icon_youtube from '../assets/icons/icon-10.webp' // YouTube
import icon_tiktok from '../assets/icons/icon-33.webp' // TikTok
import icon_reddit from '../assets/icons/icon-34.webp' // Reddit
import icon_x from '../assets/icons/icon-09.webp' // X
import icon_facebook from '../assets/icons/icon-07.webp' // Facebook
import icon_instagram from '../assets/icons/icon-08.webp' // Instagram
const jumpTo = (url: any) => {
  const w: any = window.open('_black')
  w.location.href = url
}

const DesktopRight: React.FC = () => {
  return (
    <div className="desktop-right">
      <div className="character-image">
        <img
          src={pcCharacter}
          alt="PAX AUTOCRATICA Character"
          className="character-img"
          fetchPriority="high"
        />
      </div>
      <div className="launch-eta-desktop">
        <div className="launch-arrow"></div>
        <span className="launch-text">Early Access Launch August 10<br/>(Wishlist to get notified)</span>
      </div>
      
      <div className="sidebar z-1000">
        <span className="sidebar-text font-600">
          Follow us on  <span className="sidebar-line-inline">——————</span>
        </span>
        <div className="vertical-line bg-color-fff"></div>
        <div className="sidebar-icons">
          <img src={icon_discord} alt='Discord' onClick={() => jumpTo('https://discord.gg/U2WCanzz7e')} />
          <img src={icon_youtube} alt='YouTube'onClick={() => jumpTo('https://www.youtube.com/@PaxAutocratica')} />
          <img src={icon_tiktok} alt='TikTok' onClick={() => jumpTo('http://tiktok.com/@PaxAutocratica')} />
          <img src={icon_reddit} alt='Reddit' onClick={() => jumpTo('https://www.reddit.com/r/PaxAutocratica/')} />
          <img src={icon_x} alt='X' onClick={() => jumpTo('https://x.com/paxAutocratica/')} />
          <img src={icon_facebook} alt='Facebook' onClick={() => jumpTo('https://www.facebook.com/PaxAutocratica/')} />
          <img src={icon_instagram} alt='Instagram' onClick={() => jumpTo('https://www.instagram.com/paxautocratica')} />
        </div>
      </div>
    </div>
  );
};

export default DesktopRight;